// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"551":"aa61c568","832":"3a818a51","951":"4da80a7f"}[chunkId] + ".css";
};